import { render, staticRenderFns } from "./Lock.vue?vue&type=template&id=2463709e&"
import script from "./Lock.vue?vue&type=script&lang=ts&"
export * from "./Lock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports